export default __webpack_public_path__ + "static/media/trash.0ef938c7.svg";